import { z } from "zod";

export const esquemaOtpAutenticacaoDoisFatores = z.object({
	nomeUsuario: z
		.string()
		.trim()
		.min(1, "O nome de usuário é obrigatório")
		.transform((val) => val.toUpperCase()),
});

export type EsquemaOtpAutenticacaoDoisFatores = z.infer<typeof esquemaOtpAutenticacaoDoisFatores>;
